var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information-wrapper"},[_c('Head',{attrs:{"title":_vm.$tc('header.back')}}),_c('div',{staticClass:"information-inner",domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.emptydata)?_c('Empty',{attrs:{"emptydata":_vm.emptydata}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }